(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logos"] && !Shopify.designMode) return;
  try {
    
  /* Reveal the cloud once it scrolls into view (one-shot). Falls back to visible. */
  (function () {
    var sections = document.querySelectorAll('[data-brand-cloud]');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach(function (s) { s.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    sections.forEach(function (s) { io.observe(s); });
    // Theme editor: re-run when the section is (re)loaded
    document.addEventListener('shopify:section:load', function (ev) {
      var s = ev.target.querySelector('[data-brand-cloud]');
      if (s) s.classList.add('is-visible');
    });
  })();

  /* Collapse to N sharp rows + M fading/blurred rows, with a "Show all" button.
     Rows are measured from the rendered items (works for uniform/mixed sizes and
     the 4-across mobile wrap), so the cut always lands on a row boundary. */
  (function () {
    var sections = document.querySelectorAll('[data-brand-cloud]');
    if (!sections.length) return;

    function rowsOf(cluster) {
      var rows = [], last = null;
      var items = cluster.querySelectorAll('.brand-cloud__item');
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        if (!el.offsetHeight) continue; // display:none (mobile cap)
        var top = el.offsetTop, h = el.offsetHeight;
        if (!last || top > last.top + last.h * 0.5) {
          last = { top: top, h: h };
          rows.push(last);
        } else if (h > last.h) {
          last.h = h;
        }
      }
      return rows;
    }
    function heightAt(rows, n, full) {
      var idx = Math.floor(n), frac = n - idx;
      if (idx >= rows.length) return full;
      return Math.round(rows[idx].top + frac * rows[idx].h);
    }

    function setup(section) {
      var field = section.querySelector('[data-brand-cloud-field]');
      var cluster = section.querySelector('[data-brand-cloud-cluster]');
      var more = section.querySelector('[data-brand-cloud-more]');
      var sharp = parseFloat(section.getAttribute('data-collapse-rows')) || 0;
      var fade = parseFloat(section.getAttribute('data-fade-rows')) || 0;
      if (!field || !cluster || !more || sharp <= 0) return;

      var expanded = false;

      function measure() {
        if (expanded) return;
        var rows = rowsOf(cluster);
        var full = cluster.scrollHeight;
        var sharpH = heightAt(rows, sharp, full);
        var clipH = heightAt(rows, sharp + fade, full);
        // Nothing beyond the sharp rows: show it all, no button.
        if (!rows.length || rows.length <= sharp) {
          field.classList.remove('is-collapsed');
          more.hidden = true;
          return;
        }
        field.style.setProperty('--bc-sharp', sharpH + 'px');
        field.style.setProperty('--bc-clip', clipH + 'px');
        field.style.setProperty('--bc-fade', (clipH - sharpH) + 'px');
        field.classList.add('is-collapsed');
        more.hidden = false;
      }

      more.addEventListener('click', function () {
        expanded = true;
        var from = cluster.getBoundingClientRect().height;
        field.classList.remove('is-collapsed');
        section.classList.add('is-expanded'); // also lifts the small-screen cap
        var to = cluster.scrollHeight;
        more.hidden = true;
        more.setAttribute('aria-expanded', 'true');
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        cluster.style.maxHeight = from + 'px';
        field.classList.add('is-expanding');
        // next frame: animate to the full height, then release
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            cluster.style.maxHeight = to + 'px';
          });
        });
        cluster.addEventListener('transitionend', function done(e) {
          if (e.propertyName !== 'max-height') return;
          cluster.removeEventListener('transitionend', done);
          field.classList.remove('is-expanding');
          cluster.style.maxHeight = '';
        });
      });

      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(measure, 120);
      });
      measure();
    }

    sections.forEach(setup);
    document.addEventListener('shopify:section:load', function (ev) {
      var s = ev.target.querySelector('[data-brand-cloud]');
      if (s) setup(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"]) return;
  try {
    
  document.querySelectorAll('.google-review__text').forEach((el) => {
    if (el.scrollHeight <= el.clientHeight + 2) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'google-review__more';
    btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', () => {
      const open = el.classList.toggle('is-open');
      btn.textContent = open ? 'Show less' : 'Read more';
      btn.setAttribute('aria-expanded', String(open));
    });
    el.insertAdjacentElement('afterend', btn);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  /* Homepage-editor promo slides: fade rotation, dots/arrows, pause on hover/focus/hidden tab,
     swipe on touch; no autoplay under prefers-reduced-motion. */
  (function () {
    document.querySelectorAll('[data-hero-slides]').forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-hero-slide]');
      if (slides.length < 2) return;
      var dots = hero.querySelectorAll('[data-hero-dot]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0, timer = null, paused = false, INTERVAL = 6000;

      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); if (k !== i) s.setAttribute('tabindex', '-1'); else s.removeAttribute('tabindex'); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      }
      function start() { if (reduce || paused) return; stop(); timer = setInterval(function () { go(i + 1); }, INTERVAL); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      hero.querySelector('[data-hero-prev]')?.addEventListener('click', function () { go(i - 1); start(); });
      hero.querySelector('[data-hero-next]')?.addEventListener('click', function () { go(i + 1); start(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.getAttribute('data-hero-dot'))); start(); }); });
      hero.addEventListener('mouseenter', function () { paused = true; stop(); });
      hero.addEventListener('mouseleave', function () { paused = false; start(); });
      hero.addEventListener('focusin', function () { paused = true; stop(); });
      hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) { paused = false; start(); } });
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); start(); }
      }, { passive: true });

      go(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-subnav"] && !Shopify.designMode) return;
  try {
    
  // School badge: swap the M for the school crest once the masthead's
  // big crest has scrolled up under the band (rAF-throttled scroll).
  (function () {
    var badge = document.querySelector('[data-sw-badge]');
    if (!badge) return;
    var band = badge.closest('.sw-subnav');
    var target = document.querySelector('.sw-collection__crest') || document.querySelector('.sw-collection__masthead');
    if (!band || !target) return;
    var ticking = false;
    function update() {
      ticking = false;
      var bandBottom = band.getBoundingClientRect().bottom;
      var gone = target.getBoundingClientRect().bottom <= bandBottom + 8;
      badge.classList.toggle('is-crest', gone);
    }
    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  })();

  // Dropdowns (<details data-sw-dd>): native toggle does the
  // open/close; this only adds the two behaviours <details> lacks —
  // outside click and Escape both close any open panel.
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-sw-dd][open]').forEach(function (dd) {
      if (!dd.contains(e.target)) dd.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-sw-dd][open]').forEach(function (dd) {
      dd.removeAttribute('open');
      var summary = dd.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
